namespace $ {

	export type $shm_hitalama_components_versions_entry_info = {
		version: string
		date: string
		note: string
		author: string
		root: string
		modules: number
		repository?: string
		commit?: string
	}

	export class $shm_hitalama_components_versions_entry extends $giper_baza_entity.with({
		Info: $giper_baza_atom_dict,
		Snapshot: $giper_baza_atom_link.to( ()=> $shm_hitalama_components_versions_snapshot ),
	}) {
		info() {
			this.$.$shm_hitalama_map_component_ready.read( this )
			return this.Info()?.val() as $shm_hitalama_components_versions_entry_info | null
		}
	}
}
